import React from 'react';
import { Row, Col, Layout, Card, Typography } from 'antd';
import { LuTelescope } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

import RecentQueries from './RecentQueries';
import BackLink from '../BackLink';
import QuerySearchAutocomplete from './QuerySearchAutocomplete';
import NewQuestionButton from './NewQuestionButton';
import ThinkingPhase from './ThinkingPhase';
import LoadingProgress from '../LoadingProgress';

const { Content } = Layout;
const { Title } = Typography;

const QueryDetailsLoading = ({ uuid, reloadTrigger, query }) => {
  const { t } = useTranslation();

  
  return (
    <Content className="page">
      <Row gutter={[32, 32]}>
        {/* Mobile Back Link */}
        <Col xs={24} md={0}>
          <BackLink to='/queries/new' preventHistory={true} />
        </Col>

        {/* Desktop Sidebar: Search + Recent Queries */}
        <Col xs={0} md={8} lg={8}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <QuerySearchAutocomplete/>
            <NewQuestionButton />
          </div>
          <RecentQueries
            activeQueryUuid={uuid}
            reloadTrigger={reloadTrigger}
          />
        </Col>

        {/* Desktop Loading Content */}
        <Col xs={0} md={16} lg={16}>
          <Card>
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ marginBottom: '20px' }}>
                <LuTelescope size="3em" style={{ color: '#722ed1' }} />
              </div>
              <Title level={3} style={{ marginBottom: '16px' }}>
                {t('query_details.deep_research_loading.title')}
              </Title>
              <p style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>
                {t('query_details.deep_research_loading.subtitle')}
              </p>
              <p style={{ fontSize: '14px', color: '#999' }}>
                {t('query_details.deep_research_loading.time_hint')}
              </p>
              
              {/* Show ThinkingPhase if query has content, otherwise show progress bar */}
              {query?.getAnswerWithThinking?.() ? (
                <div style={{ marginTop: '30px' }}>
                  <ThinkingPhase content={query.getAnswerWithThinking()} isCompleted={false} />
                </div>
              ) : (
                <LoadingProgress 
                  durationSeconds={300} 
                  startedAt={query?.getCreatedAt?.()}
                />
              )}
            </div>
          </Card>
        </Col>

        {/* Mobile Loading Content */}
        <Col xs={24} md={0}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <QuerySearchAutocomplete/>
            <NewQuestionButton />
          </div>
          <Card>
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ marginBottom: '20px' }}>
                <LuTelescope size="3em" style={{ color: '#722ed1' }} />
              </div>
              <Title level={3} style={{ marginBottom: '16px' }}>
                {t('query_details.deep_research_loading.title')}
              </Title>
              <p style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>
                {t('query_details.deep_research_loading.subtitle')}
              </p>
              <p style={{ fontSize: '14px', color: '#999' }}>
                {t('query_details.deep_research_loading.time_hint')}
              </p>
              
              {/* Show ThinkingPhase if query has content, otherwise show progress bar */}
              {query?.getAnswerWithThinking?.() ? (
                <div style={{ marginTop: '30px' }}>
                  <ThinkingPhase content={query.getAnswerWithThinking()} isCompleted={false} />
                </div>
              ) : (
                <LoadingProgress 
                  durationSeconds={300} 
                  startedAt={query?.getCreatedAt?.()}
                />
              )}
            </div>
          </Card>
        </Col>

        {/* Mobile Recent Queries at bottom */}
        <Col xs={24} md={0}>
          <RecentQueries
            activeQueryUuid={uuid}
            reloadTrigger={reloadTrigger}
          />
        </Col>
      </Row>
    </Content>
  );
};

export default QueryDetailsLoading; 